import { render } from "./InputWithIcon.vue?vue&type=template&id=060d8ed0&scoped=true&ts=true"
import script from "./InputWithIcon.vue?vue&type=script&lang=ts"
export * from "./InputWithIcon.vue?vue&type=script&lang=ts"

import "./InputWithIcon.vue?vue&type=style&index=0&id=060d8ed0&scoped=true&lang=css"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-060d8ed0"]])

export default __exports__